import { authenticateRequest } from '@api/authenticateRequest';

import type { components, operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type DeleteAttendUserPath =
  operations['AdminGroupEventController_deleteGroupEventMember']['parameters']['path'];
type DeleteAttendUserHeaders =
  operations['AdminGroupEventController_deleteGroupEventMember']['parameters']['header'];
type DeleteAttendUserBody = components['schemas']['AdminDeleteGroupEventMemberDto'];

interface DeleteAttendUserProps {
  path: DeleteAttendUserPath;
  headers?: OmitGroupIdInHeader<DeleteAttendUserHeaders>;
  body: DeleteAttendUserBody;
}

type DeleteAttendUserResponse = number;

export async function deleteAttendUser({
  path,
  headers,
  body,
}: DeleteAttendUserProps): Promise<DeleteAttendUserResponse | false> {
  const response = await authenticateRequest<DeleteAttendUserResponse>({
    method: 'delete',
    url: `/api/v1/admin/group-event/${path.groupEventId}/members`,
    headers,
    data: body,
  });

  console.log('deleteAttendUser', { response });
  return response;
}
